jQuery(function( $ ){

$('#lightgallery').lightGallery({
    selector: '.item'
});
  
    $('#lightgallery2').lightGallery({
    selector: '.item'
});
  
    $('#lightgallery3').lightGallery({
    selector: '.item'
});
  
    $('#lightgallery4').lightGallery({
    selector: '.item'
});
  
      $('#lightgalleryslider').lightGallery({
});

  
  $("#html5-videos").lightGallery();
  
  $('.open-website').lightGallery({
      selector: 'this',
      iframeMaxWidth: '80%'
  });

});